import { Message } from 'element-ui'

export const notifyMessage = (opt: any) => {
  Message(opt)
}

export const notifySuccess = (success: any) => {
  Message.success({
    message: success,
    type: 'success',
    showClose: true
  })
}

export const notifyError = (error: any) => {
  const response = error.response

  // Not sure how this occurs, Maybe a Timeout?
  if (response === undefined) {
    Message.error({
      message: error,
      type: 'error',
      showClose: true
    })
    return
  }

  // API error with errors collection with Model validation errors
  if ('data' in response) {
    const { data } = response
    console.log(` Error-display.notify: ${data.title} `)
    if ('errors' in data) {
      let allErrors: Array<string> = []
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      for (const [key, array] of Object.entries(data.errors)) {
        // use `spread syntax` to combine all error messages
        allErrors = [...allErrors, ...(array as Array<string>)]
      }

      let msg = `<div class='error-from-api'><p>${data.title}</p><ul>`
      for (const v of allErrors) {
        msg = msg + `<li>${v}</li>`
      }
      msg += '</ul></div>'

      Message({
        message: msg,
        dangerouslyUseHTMLString: true,
        type: 'error',
        showClose: true,
        duration: 20000
      })
    } else {
      Message({
        message: data.title,
        type: 'error',
        showClose: true,
        duration: 20000
      })
    }
    return
  }

  // 400 error response from api has { status, title, detail, traceId }
  if ('title' in response) {
    console.error(` Error-display.notify: ${response.title} `)

    Message({
      message: response.title,
      type: 'error',
      showClose: true
    })
    return
  }

  // unknown error response from api
  Message({
    // title: 'Unexpected error.',
    message: error,
    type: 'error',
    showClose: true
  })
}
